package com.essntl.features.crm.ui

sealed interface CRMEvent {
    data class GetOrganizationList(
        val type: String,
        val searchText: String = "",
        val delay: Boolean = false,
    ) : CRMEvent

    data class Toggle(val index: Int) : CRMEvent
}